import { useState, useMemo } from 'react';
// @ts-ignore
import { McpEditor, DEFAULT_MCP_STATE, DEFAULT_MCP_CONNECTIONS } from 'peak-editor-components';

interface McpConfigTabProps {
  data: any;
  onChange: (key: string, value: any) => void;
}

const COMMON_PROPS = {
    variablesJson: JSON.stringify({ input: { text: 'Hello World' }, context: { user: 'admin' } }, null, 2),
    onVariablesChange: () => {},
    functions: [],
    onFunctionsChange: () => {},
    showVariables: true,
    showFunctions: true,
    showAi: true
};

export const McpTab: React.FC<McpConfigTabProps> = ({ data, onChange }) => {
  // Local state for connections list (in a production app, fetch from DataProvider)
  const [connections, setConnections] = useState(DEFAULT_MCP_CONNECTIONS || []);

  // Derived state for the editor config
  // We default to a safe object if the node data is empty
  const config = useMemo(() => {
      return data.mcpConfig || DEFAULT_MCP_STATE || {
          serverType: 'stdio',
          command: 'npx',
          args: ['-y', '@modelcontextprotocol/server-filesystem', '/Users/username/Desktop'],
          env: {}
      };
  }, [data.mcpConfig]);

  // Track active connection ID
  const [activeConnectionId, setActiveConnectionId] = useState(data.connectionId || '');

  const handleConfigChange = (newConfig: any) => {
      onChange('mcpConfig', newConfig);
  };

  const handleConnectionChange = (id: string) => {
      setActiveConnectionId(id);
      onChange('connectionId', id);
  };

  return (
    <div className="flex flex-col h-full bg-slate-50">
      <div className="px-4 py-3 border-b border-slate-200 bg-white flex items-center gap-4">
          <label className="text-xs font-bold text-slate-500 uppercase shrink-0">Result Variable</label>
          <input
              type="text"
              className="flex-1 max-w-xs border border-slate-300 rounded-lg px-3 py-1.5 text-sm outline-none font-mono focus:border-teal-500 focus:ring-1 focus:ring-teal-500/20"
              value={data.resultVariable || ''}
              onChange={e => onChange('resultVariable', e.target.value)}
              placeholder="mcpResult"
          />
          <span className="text-[10px] text-slate-400">Stores the operation response.</span>
      </div>
      <div className="flex-1 relative min-h-[600px]">
        <McpEditor
            config={config}
            onChange={handleConfigChange}
            connections={connections}
            onUpdateConnections={setConnections}
            activeConnectionId={activeConnectionId}
            onActiveConnectionChange={handleConnectionChange}
            {...COMMON_PROPS}
        />
      </div>
    </div>
  );
};
